/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import QueryService from './QueryService';
import { COMPONENT_QUERY_PARAMS } from './NavigationConstants';

class TableQueryService extends QueryService {
  constructor(history, location) {
    super();
    this.history = history;
    this.location = location;
  }

  getPathName = () => {
    return this.location?.pathname;
  };

  setPage = (page) => {
    const currentQuery = this.parseQuery();
    currentQuery[COMPONENT_QUERY_PARAMS.PAGE] = page;
    this.setHistory(`?${this.stringify(currentQuery)}`);
  };

  setPageSize(size) {
    const currentQuery = this.parseQuery();
    currentQuery[COMPONENT_QUERY_PARAMS.SIZE] = size;
    this.setHistory(`?${this.stringify(currentQuery)}`);
  }

  setSort(sort) {
    const currentQuery = this.parseQuery();
    currentQuery[COMPONENT_QUERY_PARAMS.SORT] = `${sort?.sortColumn},${sort?.sortOrder}`;
    this.setHistory(`?${this.stringify(currentQuery)}`);
  }

  setFilter(filters) {
    const currentQuery = this.parseQuery();
    const _filters = filters?.map(filter => `${filter.type}|${filter.value}`).toString();

    if (_filters?.length > 0) {
      currentQuery[COMPONENT_QUERY_PARAMS.FILTER] = _filters;
    } else {
      delete currentQuery[COMPONENT_QUERY_PARAMS.FILTER];
    }
    this.setHistory(`?${this.stringify(currentQuery)}`);
  }

  setHistory = (searchParam) => {
    this.history.replace({
      pathname: this.getPathName(),
      search: searchParam,
    });
  };
}

export { TableQueryService };
